import React from "react";
import SVGButton from "../Buttons/SVGButton";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { useSession } from "../../authentications/SessionContext";
import { primaryColor } from "../../utilities/colors";
import FormikInput from "../Formik/FormikInput";
import Translator from "./Translator";
// import { useFormikContext } from "formik";

function AttributeValueRow({
  index,
  setFieldValue,
  item,
  name,
  disabled,
  modelSpecific,
  color,
  fieldName,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  setUpdatedData,
  modalType,
  isColor,
  touched,
  errors,
  values,
}) {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  // console.log("disabled", disabled);

  return (
    <tr key={index}>
      <td
        style={{
          minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH,
          position: "relative",
        }}
      >
        {!disabled && modalType === "edit" && (
          <Translator
            productId={item.id}
            modelSpecific={modelSpecific}
            color={color}
            fieldName={fieldName}
            fieldValue={item.name}
            isCreateModalOpen={isCreateModalOpen}
            setIsCreateModalOpen={setIsCreateModalOpen}
            updatedData={updatedData}
            setUpdatedData={setUpdatedData}
            right={"32px"}
            top={"-5px"}
          />
        )}
        <FormikInput name={`${name}.${index}.name`} disabled={disabled} />
      </td>

      <td style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}>
        <FormikInput
          name={`${name}.${index}.hexCode`}
          disabled={disabled || !values?.isColor}
        />
      </td>
      {!disabled && (
        <td className="d-flex justify-content-center align-items-center mt-auto">
          <SVGButton
            icon={"deleteIcon"}
            hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
            onClick={() => {
              setFieldValue(`${name}.${index}`, { ...item, isDeleted: true });
            }}
          />
        </td>
      )}
    </tr>
  );
}

export default AttributeValueRow;
